import { render, staticRenderFns } from "./scanPackageByLs.vue?vue&type=template&id=047fad85&scoped=true"
import script from "./scanPackageByLs.vue?vue&type=script&lang=js"
export * from "./scanPackageByLs.vue?vue&type=script&lang=js"
import style0 from "./scanPackageByLs.vue?vue&type=style&index=0&id=047fad85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fad85",
  null
  
)

export default component.exports